window.Vivense = window.Vivense || {};

Vivense.favoriteActions = (function($) {

    var exports = {};

    function addFavorite(productId){
        var postData = {
            productId: productId,
            addedPage : '',
            formToken:window.formToken
        };

        if(window.currentPage){
            postData.addedPage = window.currentPage
        }

        $.post('/index.php?option=com_users&task=setUserProductFavorite', $.param(postData));

    }

    function removeFromFavorite(productId){
        var postData = {
            productId:productId,
            formToken:window.formToken
        };

        $.post('/index.php?option=com_users&task=deleteUserProductFavorite', $.param(postData));
    }

    function initFavoriteProducts(){
        var products = JSON.parse(window.favoriteProducts);

        for(var i=0;i<products.length;i++){
            $(".favorite-area-hearth input[type=checkbox][value="+products[i]+"]").prop('checked',true);
        }
    }

    function init(){

        $(".favorite-area-hearth input[type=checkbox]").on('click', function(){

            if(parseInt(window.userId) === 0 ){
                $(this).prop('checked',false);
                if(Vivense.loginPopup){
                    $(".login-form-slide-box").removeClass("slide-register");
                    $('#registrationForm .inner-center-mod .favorites-text').show();
                    $("#registrationForm .inner-center-mod .short-desc").hide();
                    $("#registrationForm .inner-center-mod .login-text").hide();
                    $(".popup-action-title").removeClass("active-tab");
                    $(".register-title").addClass("active-tab");
                    Vivense.loginPopup.open("favorites");
                    return;
                }

                window.location.href = '/vivense-uye-girisi.html';
                return;
            }

            if($(this).prop("checked")){
                addFavorite($(this).val());
            }
            else{
                removeFromFavorite($(this).val());
            }


        });

        initFavoriteProducts();
    }

    $(document).ready(init);

    exports.init = init;
    exports.addFavorite = addFavorite;
    exports.initFavoriteProducts = initFavoriteProducts;

    return exports;

})(jQuery);